// extracted by mini-css-extract-plugin
export default {"question":"style_question__Nf-My","codeBlock":"style_codeBlock__9lllT"};